import { render, staticRenderFns } from "./NewsMessageManage.vue?vue&type=template&id=380a22e2&scoped=true"
import script from "./NewsMessageManage.vue?vue&type=script&lang=js"
export * from "./NewsMessageManage.vue?vue&type=script&lang=js"
import style0 from "./NewsMessageManage.vue?vue&type=style&index=0&id=380a22e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a22e2",
  null
  
)

export default component.exports